export function GetReadOnlyEmptyStateCreateMessage(entity: string) {
    return `You don't have access to create ${entity}. Contact an administrator of this account for details.`;
}

export function GetReadOnlyEmptyStateAccessMessage(entity: string, addOrAnyVerbiage: string) {
    return `You don't have access to ${addOrAnyVerbiage} ${entity}. Contact an administrator of this account for details.`;
}
